<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import mdiPencil from '~icons/mdi/pencil'
import { isUserToken } from '@/stores/authStore'
import { useAuth } from '@/composables/useAuth'
import { useUserExtendedData } from '@/composables/useUserExtendedData'
import { useQuery } from '@/composables/api'

const auth = useAuth()
const userExtendedData = useUserExtendedData()
const { t } = useI18n()
const router = useRouter()

const isVismaNet = computed(() => userExtendedData.data.value?.oauth_type === 'visma_net')
const multipleTenants = computed(
  () => isUserToken(auth.selectedToken.value?.payload) && (auth.selectedToken.value.payload.vnet_tenant_c ?? 0) > 1
)

const accountQuery = useQuery(
  '/accounts/{resource_id}',
  computed(() => ({
    path: { resource_id: userExtendedData.data.value?.account ?? '' },
  })),
  { enabled: isVismaNet }
)

function changeTenant() {
  const returnTo = router.currentRoute.value.fullPath != '/' ? router.currentRoute.value.fullPath : undefined
  void auth.signInWithRedirect('visma_net', {
    returnUrl: returnTo,
  })
  auth.signOut()
}
</script>

<template>
  <v-hover
    v-if="isVismaNet && multipleTenants && accountQuery.data.value != null"
    v-slot="{ isHovering, props: hoverProps }"
    :close-delay="100"
  >
    <v-btn
      v-bind="hoverProps"
      variant="outlined"
      density="comfortable"
      class="pl-8"
      @click="changeTenant()"
    >
      {{ accountQuery.data.value.name }}

      <template #append>
        <v-icon
          :class="{ 'visibility-hidden': !isHovering }"
          size="small"
          :icon="mdiPencil"
        />
      </template>

      <v-tooltip
        activator="parent"
        location="bottom"
      >
        {{ t('common.switch_user') }}
      </v-tooltip>
    </v-btn>
  </v-hover>
</template>

<style scoped>
.visibility-hidden {
  visibility: hidden;
}
</style>
